<template>
    <div class="notas-fiscais">
      <g-card
        class="card-notas-fiscais"
        margem="20px"
        :expansivel="true"
        :comecaFechado="false">
        <template #cabecalho>
            <div class="header-filtros">
                <div class="titulo-filtros-cabecalho"> Notas Fiscais </div>
                <div class="header-icons">
                <g-button
                class="trash-box"
                tipo="cinza"
                altura="35px"
                largura="45px"
                icone="icone_lixo.svg"
                tamanhoIcone="15px"
                somenteIcone
                :sombreado="false"
                v-tooltip="'Limpar filtro'"
                @click="limpar"
                />
                <g-button
                class="buscar-button-header-filtro"
                largura="150px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="buscar()"
                >
                    BUSCAR
                </g-button>
                </div>
            </div>
        </template>

        <g-form>
            <div class="notas-fiscais-conteudo espacamento-filtros">
                <div class="numero-nota">
                    <div class="numero-nota-titulo titulo-conteudo-filtros"> Número da Nota </div>
                    <PInputText
                    class="numero-nota-input input-label"
                    placeholder="Insira o número da nota"
                    v-model="objFiltros.NumeroNota"
                    />
                </div>

                <div class="data-emissao">
                    <div class="data-emissao-titulo titulo-conteudo-filtros"> Data de Emissão </div>
                        <div class="input-data">
                            <div class="data-inicio">
                            <g-date-input
                            class="data-emissao-inicio-input input-label"
                            placeholderinput="Início"
                            alturainput = "40px"
                            largurainput = "100%"
                            tamanhobotao = "35px"
                            invertido
                            :dataPassadas="true"
                            v-model="objFiltros.DataEmissaoInicio"
                            ></g-date-input>
                            </div>
                            <div class="data-periodo"> à </div>
                            <div class="data-termino">
                            <g-date-input
                            class="data-emissao-termino-input input-label"
                            placeholderinput="Término"
                            alturainput = "40px"
                            largurainput = "100%"
                            tamanhobotao = "35px"
                            invertido
                            :dataPassadas="true"
                            v-model="objFiltros.DataEmissaoTermino"
                            ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="numero-pedido">
                        <div class="numero-pedido-titulo titulo-conteudo-filtros"> Número do Pedido </div>
                        <PInputText
                        class="numero-pedido-input input-label"
                        placeholder="Insira o número do pedido"
                        v-model="objFiltros.NumeroPedido"
                        />
                    </div>

                    <div class="status">
                        <div class="status-titulo titulo-conteudo-filtros"> Status </div>
                        <PDropDown
                        class="status-input input-label"
                        placeholder="Selecione"
                        :options="SituacaoArray"
                        optionLabel="text"
                        optionValue="value"
                        v-model="objFiltros.Situacao"
                        />
                    </div>

                    <div class="cliente">
                        <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
                        <!-- <VMultiSelect
                        class="cliente-input input-label"
                        placeholder="Selecione o cliente"
                        :filter="true"
                        optionLabel="nomeFantasia"
                        v-model="objFiltros.ClienteId"
                        @filter="buscarClientes($event.value)"
                        :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                        :options="ClienteArray"
                        optionValue="id"
                        >
                            <template #option="slotProps">
                                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                            </template>
                        </VMultiSelect> -->
                        <cliente-dropdown
                            class="cliente-input input-label"
                            v-model="objFiltros.ClienteId"
                            @change="ativaClienteAgrupador"
                            :empresaId="objFiltros.UnidadeId"
                            :representanteId="this.$store.state.representanteSelecionadoId"
                        />
                    </div>

                    <div class="codigo-nome-produto">
                        <div class="codigo-produto">
                            <div class="codigo-produto-titulo titulo-conteudo-filtros"> Nome do Produto </div>
                            <PDropDown
                            :options="ProdutoArray"
                            @filter="getProduto($event.value)"
                            :filter="true"
                            optionLabel="labelProduto"
                            optionValue="produtoId"
                            class="nome-produto-input input-label"
                            placeholder="Insira o nome do produto"
                            v-model="objFiltros.NomeProduto"
                            />
                        </div>
                    </div>

                    <div class="unidade">
                        <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                        class="unidade-input input-label unidade"
                        placeholder="TODAS"
                        :filter="true"
                        :options="EmpresaArray"
                        optionLabel="nome"
                        optionValue="id"
                        v-model="objFiltros.UnidadeId"
                        >
                        </PDropDown>
                    </div>

                    <div class="parametros">
                        <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
                        <div class="parametros-checkboxes">
                            <div class="consultar-dados checkbox">
                                <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados"  class="checkbox-consultas" v-model="objFiltros.ConsultarDadosClienteAgrupador"></PCheckBox>
                                <label  class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                            </div>
                            <div class="quebra-produto checkbox">
                                <PCheckBox :binary="true" id="quebra-produto"  class="checkbox-quebraProduto" v-model="objFiltros.QuebraPorProduto"></PCheckBox>
                                <label class="quebraProduto label-checkbox" for="quebra-produto"> Quebra por produto </label>
                            </div>
                        </div>
                    </div>
                </div>
            </g-form>

            <div class="buscar-button-filtro">
                <g-button
                class="buscar-button"
                largura="300px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="buscar()"
                >
                BUSCAR
                </g-button>
            </div>
        </g-card>

        <g-card paddingDefault="0 0em 1em" margem="20px" :expansivel="false" :temCabecalho="false" class="card-resultado">
            <div v-if="grid" class="">
            <img
            class="icone-global-imagemfundo"
            src="@/assets/imgs/Ilustracao_erro.svg"
            />
            <div class="texto-padrao-imagemfundo">
                Verifique os filtros e clique em buscar para exibir os resultados
            </div>
            </div>

            <div v-else-if="!grid">
            <g-data-table
                Titulo="Notas Fiscais"
                altura="auto"
                :colunas="Colunas"
                :valores="NotasFiscaisArray"
                :Paginacao="true"
                :NumeroLinhas="100"
                :FiltrosEspecificos="true"
                :Financeiro="true"
                TextFinanceiro="Títulos vinculados a nota fiscal"
                :Pedidos="true"
                TextPedidos="Pedidos vinculados a nota fiscal"
                v-on:OnPedidos="pedidosRota"
                v-on:financeiro="titulosRota"
                :Filtros="Filtro"
                v-on:duploClickLinha="telaDetalhes"
                :campoAgrupador="'empresaCliente'"
                :campoExibicaoGrupo="'empresaCliente'"
                dataKey="notaFiscalId"
                :telaNotasFiscais="true"
            >       
            <template #groupfooter="slotProps">    
            <g-data-table
                :valores="[{}]"
                :ehSemDados="false"
                :ehReordenavel="false"
                :Paginacao = false
                :colunas="[
                        {header: 'Total Cliente: '},
                        {header: ''},
                        {header: ''},
                        {header: slotProps.soma.valorSomaNotaFiscal },
                        {header: ''},
                ]"
                :esconderHeader="true"
                :esconderColunaFrozen="true"
            >
            </g-data-table>
        </template>
    </g-data-table>
            </div>
        </g-card>
    </div>
</template>


<script>
import NotasFiscais from './NotasFiscais.js'
export default NotasFiscais
</script>

<style scoped>
.card-notas-fiscais-header {
    display: flex;
    justify-content: space-between;
}

.header-icons-consulta {
    display: flex;
    justify-content: flex-end;
}

.trash-box-consulta {
    margin-left: 5px;
}

.card-notas-fiscais-titulo {
    color: #4f2c19;
    text-align: left;
    font-weight: bold;
    align-self: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.titulo {
    color: #747474;
    text-align: left;
    font-family: Montserrat;
    font-weight: bold;
    padding: 5px 0;
}

.checkbox {
    display: flex;
    padding-top: 3px;
    padding-bottom: 3px;
}

.label-checkbox {
    color: #8A8A8A;
    text-align: left;
    font-size: 15px;
    font-family: 'MontSerrat';
    margin-left: 5px;
}

.input-label {
    margin-bottom: 15px;
}

.card-resultado-text-small {
    color: #4F4C4D;
    font-family: 'MontSerrat';
}

.card-resultado-content {
    display: flex;
    flex-direction: column;
}

.imagem-nenhuma-info {
    margin: 60px auto 20px auto;
    max-height: 500px;
}

.buscar-button-consulta {
    display: flex;
    align-content: center;
    justify-content: center;
}

.data-emissao-periodo {
    color: #747474;
    font-family: Montserrat;
}

.codigo-nome-produto {
    width: 100%;
}


@media (min-width: 310px) {
.unidade { order: 1 }
.buscar-button-header {
    display: none;
}

.card-notas-fiscais-titulo {
    font-size: 16px;
}

/* .notas-fiscais-conteudo {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
} */

.notas-fiscais-conteudo {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(8, auto);
    grid-column-gap: 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 2 / 1 / 2 / 2; }
.numero-nota { grid-area: 3 / 1 / 4 / 2; }
.numero-pedido { grid-area: 4 / 1 / 5 / 2; }
.codigo-nome-produto { grid-area: 5 / 1 / 6 / 2; }
.status { grid-area: 6 / 1 / 7 / 2; }
.parametros { grid-area: 7 / 1 / 8 / 2; }
.data-emissao { grid-area: 8 / 1 / 9 / 2; }

.titulo {
    font-size: 14px;
}

.data-emissao-input {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 100%;
    grid-column-gap: 4%;
}
.data-emissao-inicio { grid-area: 1 / 1 / 2 / 2; }
.data-emissao-periodo { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.data-emissao-termino { grid-area: 1 / 3 / 2 / 4; }

.input-label {
    width: 100%;
}

.buscar-button-filtro {
  display: flex;
  justify-content: center;
  align-items: self-end;
}

.imagem-nenhuma-info {
    height: 15vh;
}
}

@media (min-width: 368px) {
.card-notas-fiscais-titulo {
    font-size: 18px;
}
}

@media (min-width: 600px) {
.buscar-button-header {
    display: block;
    margin-left: 15px;
}

.card-notas-fiscais-titulo {
    font-size: 20px;
}
/*
.notas-fiscais-conteudo {
    display: grid;
    grid-template-columns: 47% 49.5%;
    grid-template-rows: repeat(6, auto);
    grid-column-gap: 20px;
}

.numero-nota { grid-area: 1 / 1 / 2 / 2; }
.data-emissao { grid-area: 1 / 2 / 2 / 3; }
.numero-pedido { grid-area: 2 / 1 / 3 / 2; }
.status { grid-area: 2 / 2 / 3 / 3; }
.codigo-nome-produto { grid-area: 3 / 1 / 4 / 3; }
.unidade { grid-area: 4 / 1 / 5 / 3; }
.cliente { grid-area: 5 / 1 / 6 / 3; }
.parametros { grid-area: 6 / 1 / 7 / 3; } */


.buscar-button-filtro {
  display: none;
}

.imagem-nenhuma-info {
    height: 25vh;
}
}

@media (min-width: 801px) {
.notas-fiscais-conteudo {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(6, auto);
    margin: 20px 20px 0 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-nota { grid-area: 3 / 1 / 4 / 2; }
.numero-pedido { grid-area: 3 / 2 / 4 / 3; }
.codigo-nome-produto { grid-area: 5 / 1 / 6 / 2; }
.status { grid-area: 5 / 2 / 6 / 2; }
.parametros { grid-area: 7 / 2 / 8 / 3; }
.data-emissao { grid-area: 7 / 1 / 8 / 2; }

/* .unidade { grid-area: 4 / 1 / 5 / 2; }
.cliente { grid-area: 4 / 2 / 5 / 3; }
.parametros { grid-area: 5 / 1 / 6 / 3; } */

.parametros-checkboxes {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    column-gap: 20px;
}
}

@media (min-width: 1025px) {
.card-notas-fiscais-titulo {
    font-size: 22px;
}

.notas-fiscais-conteudo {
    grid-template-columns: 49% 49%;
    grid-template-rows: repeat(4, auto);
    margin: 20px 20px 0 20px;
}

.card-resultado-text-small { font-size: 16px; }

.imagem-nenhuma-info {
    height: 35vh;
}
}

@media (min-width: 1281px) {
.notas-fiscais-conteudo {
    grid-template-columns: repeat(4, minmax(6em, 1fr));
    grid-template-rows: repeat(3, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-nota { grid-area: 1 / 3 / 2 / 4;  }
.numero-pedido { grid-area: 1 / 4 / 2 / 5; }
.codigo-nome-produto { grid-area: 2 / 1 / 3 / 2; }
.status { grid-area: 2 / 2 / 3 / 3;}
.data-emissao { grid-area: 2 / 3 / 3 / 4; }
.parametros { grid-area: 2 / 4 / 3 / 5; }
}

@media (min-width: 1500px) {
.notas-fiscais-conteudo {
    grid-template-columns: repeat(2, 24%) 24.5% 24%;
    grid-template-rows: repeat(2, auto);
}

/* .unidade { grid-area: 2 / 3 / 3 / 4; }
.cliente { grid-area: 2 / 4 / 3 / 5; }
.parametros { grid-area: 3 / 1 / 4 / 3; } */
}
</style>